import { useState, useEffect } from 'react'
import { Flame, Clock, Percent } from 'lucide-react'

interface CountdownTime {
	hours: number
	minutes: number
	seconds: number
}

const PromoCountdownBanner = () => {
	const [timeLeft, setTimeLeft] = useState<CountdownTime>({
		hours: 0,
		minutes: 0,
		seconds: 0,
	})

	useEffect(() => {
		const calculateTimeLeft = (): CountdownTime => {
			const now = new Date()
			const tomorrow = new Date(now)
			tomorrow.setDate(tomorrow.getDate() + 1)
			tomorrow.setHours(0, 0, 0, 0) 

			const difference = tomorrow.getTime() - now.getTime()

			if (difference > 0) {
				return {
					hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
					minutes: Math.floor((difference / 1000 / 60) % 60),
					seconds: Math.floor((difference / 1000) % 60),
				}
			}

			return { hours: 0, minutes: 0, seconds: 0 }
		}

		setTimeLeft(calculateTimeLeft())

		const timer = setInterval(() => {
			setTimeLeft(calculateTimeLeft())
		}, 1000)

		return () => clearInterval(timer)
	}, [])

	const formatNumber = (num: number): string => {
		return num.toString().padStart(2, '0')
	}

	return (
		<div className='mb-6 lg:mb-8'>
			<div className='bg-gradient-to-r from-red-600 via-red-700 to-red-600 rounded-xl p-4 sm:p-6 shadow-lg'>
				<div className='flex flex-col sm:flex-row items-center justify-between gap-4'>
					<div className='flex items-center gap-3 text-white'>
						<div className='bg-white/20 rounded-full p-2 animate-pulse'>
							<Flame className='w-5 h-5' />
						</div>
						<div>
							<h3 className='font-black text-lg sm:text-xl'>
								🔥 ¡OFERTAS CANDENTES!
							</h3>
							<p className='text-red-100 text-sm'>
								Productos seleccionados con descuentos únicos
							</p>
						</div>
					</div>

					<div className='flex items-center gap-2 sm:gap-4 text-white'>
						<div className='flex items-center gap-2 bg-white/20 rounded-lg px-2 sm:px-3 py-2'>
							<Clock className='w-4 h-4' />
							<div className='flex items-center gap-1 font-mono font-bold text-xs sm:text-sm'>
								<span className='bg-white/30 rounded px-1 sm:px-2 py-1 min-w-[24px] sm:min-w-[28px] text-center'>
									{formatNumber(timeLeft.hours)}
								</span>
								<span className='text-white/80'>:</span>
								<span className='bg-white/30 rounded px-1 sm:px-2 py-1 min-w-[24px] sm:min-w-[28px] text-center'>
									{formatNumber(timeLeft.minutes)}
								</span>
								<span className='text-white/80'>:</span>
								<span className='bg-white/30 rounded px-1 sm:px-2 py-1 min-w-[24px] sm:min-w-[28px] text-center animate-pulse'>
									{formatNumber(timeLeft.seconds)}
								</span>
							</div>
						</div>

						<div className='flex items-center gap-2 bg-white/20 rounded-lg px-2 sm:px-3 py-2'>
							<Percent className='w-4 h-4' />
							<span className='font-bold text-xs sm:text-sm'>
								Hasta 50% OFF
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PromoCountdownBanner
